<template>
  <div>
    <b-alert
      v-for="(item, index) in terapiasList"
      :key="index" 
      show 
      :variant="getVariantCard(item.action)" 
      class="my-1 p-1"
    >

      <div class="d-flex justify-content-end align-items-center">
        <span class="text-muted mr-1">{{ item.action.toUpperCase() }}</span>
        <b-button 
          :variant="showCardComplete.includes(index) ? 'info' : ''" 
          size="sm" 
          @click="onViewItem(index)"
        >
          <i class="fa-solid fa-magnifying-glass"/>
        </b-button>

        <b-button 
          v-if="item.action !== 'eliminar'"
          variant="danger" 
          size="sm"
          class="ml-1"
          @click="onRemoveItemList(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>

        <b-button 
          v-if="item.action === 'eliminar'"
          variant="warning" 
          size="sm"
          class="ml-1"
          @click="onRestoreItem(index)"
          title="Restaurar Item"
        >
          <i class="fa-solid fa-rotate-right"/>
        </b-button>
      </div>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="col-2">N. Order: </strong> 
        <span class="text-dark col">{{ item.numeroOrden }}</span>
      </b-row>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="col-2">Terapia: </strong> 
        <span class="text-dark col">{{ item.terapia.text }}</span>
      </b-row>

      <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
        <strong class="col-2">Cantidad: </strong> 
        <span class="text-dark col">{{ item.cantidad }}</span>
      </b-row>

      

      <span v-if="showCardComplete.includes(index)">
        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="col-3">Motivo de solicitud: </strong> 
          <span class="text-dark col">{{ item.motivoSolicitud }}</span>
        </b-row>

        <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
          <strong class="col-3">Resumen Clinico: </strong> 
          <span class="text-dark col">{{ item.resumenClinico }}</span>
        </b-row>
      </span>

    </b-alert>
  </div>
  
</template>

<script>
export default {

  props: {
    terapiasList: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showCardComplete: []
    }
  },


  methods:{

    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists 
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },



    async onRemoveItemList(index){

      const result = await this.$swal.fire({
        title: 'Eliminar Item Examen',
        text: "Estas seguro de eliminar este examen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.terapiasList[index].action === 'registrado'){
        this.terapiasList[index].action = 'eliminar';
        return;
      }

      this.terapiasList.splice(index, 1)
    },


    onRestoreItem(index){
      this.terapiasList[index].action = 'registrado'
    }

  }
}
</script>

<style>

</style>